import { Box, Flex } from '@/components/atoms/Grid'
import { Capitalized, Tiny } from '@/components/atoms/typography'
import { FC } from 'react'
import styled from 'styled-components'
import { BlogAuthor } from '@/network/graphql.g'
import ResponsiveImage from '@/components/atoms/responsiveImage'
import { UserIconDefault } from '@/components/atoms/icons/UserIconDefault'

type BlogAuthorProps = {
  author: BlogAuthor
}

const PostDetailAboutAuthor: FC<BlogAuthorProps> = ({ author }) => {
  const { name, description, photo } = author
  return (
    <StyledFlex>
      <ImageWrapper>
        <StyledUserIconDefault width={50} height={50} />
        {/** responsiveImage bude požitý keď budú dostupné obrázky */}
        <ResponsiveImage imageUrl={photo} layout="fill" objectFit="cover" />
      </ImageWrapper>
      <Box maxWidth="65%">
        <NameOfAuthor>{name}</NameOfAuthor>
        <AboutAuthor>{description}</AboutAuthor>
      </Box>
    </StyledFlex>
  )
}

export default PostDetailAboutAuthor

const StyledFlex = styled(Flex)`
  box-sizing: border-box;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 20px;
  padding: 20px;
  min-height: 120px;
  margin-block: 48px;
  background-color: ${(props) => props.theme.colors.blogNeutralBackground}; ;
`

const ImageWrapper = styled(Box)`
  position: relative;
  width: 65px;
  height: 65px;
  border-radius: 50%;
  overflow: hidden;
  border-color: #000000;
`
const NameOfAuthor = styled(Capitalized)`
  letter-spacing: 1.2px;
  line-height: 1.6;
  margin: 0;
`

const AboutAuthor = styled(Tiny)`
  font-weight: normal;
  line-height: 1.6;
  margin: 0;
`

const StyledUserIconDefault = styled(UserIconDefault)`
  position: absolute;
  top: 12%;
  left: 12%;
`
